module.exports = __webpack_public_path__ + "static/media/Caroline-Sam_2x.cbfc02fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/Caroline-Sam_2x.png
// module id = 1277
// module chunks = 50